// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".moc-timeline {\n  max-height: 550px;\n}\n.moc-timeline .q-timeline__heading-title {\n  padding-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
